import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import billingApi from "../../redux2/billing/apiBilling";
import moment from "moment";

const ViewRemarkTransaction = ({ remark, reference }) => {
  const [openModal, setOpenModal] = useState(false);
  const [billing, setBilling] = useState(null);

  const handleClick = () => {
    setOpenModal(true);
  };

  useEffect(() => {
    const fetchBilling = async () => {
      const user = localStorage.getItem("user");
      const token = user ? JSON.parse(user).token : null;
      const res = await billingApi.getBillingByReference(token, reference);
      setBilling(res);
    };

    if (reference) {
      fetchBilling();
    }
  }, [reference]);

  return (
    <>
      <div
        className="text-gray-700 transition-colors duration-200 cursor-pointer hover:text-blue-600"
        onClick={handleClick}
      >
        View Remark
      </div>

      <Modal
        show={openModal}
        onHide={() => setOpenModal(false)}
        size="lg"
        centered
        backdrop="static"
      >
        <div className="bg-white rounded-lg shadow-xl">
          {/* Header */}
          <div className="flex justify-between items-center p-6 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-gray-800">
              Transaction Remark
            </h2>
            <button
              type="button"
              className="text-gray-400 transition-colors duration-200 hover:text-gray-600"
              onClick={() => setOpenModal(false)}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          {/* Body */}
          <div className="p-6">
            {/* Remark Details */}
            <div className="p-4 bg-gray-50 rounded-lg border border-gray-200">
              <label className="block mb-2 text-sm font-medium text-gray-700">
                Remark Details:
              </label>
              <div className="leading-relaxed text-gray-800 whitespace-pre-wrap">
                {remark || "No remark available"}
              </div>
            </div>

            {/* Transaction Details */}
            {billing && (
              <div className="mt-6">
                <h3 className="mb-4 text-lg font-medium text-gray-800">
                  Transaction Details
                </h3>
                <div className="space-y-3">
                  <div className="flex justify-between py-2 border-b border-gray-100">
                    <span className="text-gray-600">Transaction ID:</span>
                    <span className="font-medium text-gray-900">
                      {billing.transaction || "N/A"}
                    </span>
                  </div>
                  <div className="flex justify-between py-2 border-b border-gray-100">
                    <span className="text-gray-600">Type:</span>
                    <span className="font-medium text-gray-900 capitalize">
                      {billing.type || "N/A"}
                    </span>
                  </div>
                  <div className="flex justify-between py-2 border-b border-gray-100">
                    <span className="text-gray-600">Bank:</span>
                    <span className="font-medium text-gray-900 uppercase">
                      {billing.bank || "N/A"}
                    </span>
                  </div>
                  <div className="flex justify-between py-2 border-b border-gray-100">
                    <span className="text-gray-600">Amount:</span>
                    <span className="font-medium text-gray-900">
                      {billing.deposit
                        ? `ETB ${billing.deposit.toLocaleString()}`
                        : "N/A"}
                    </span>
                  </div>
                  <div className="flex justify-between py-2 border-b border-gray-100">
                    <span className="text-gray-600">Approved By:</span>
                    <span className="font-medium text-gray-900">
                      {billing.approvedBy || "N/A"}
                    </span>
                  </div>
                  <div className="flex justify-between py-2">
                    <span className="text-gray-600">Created At:</span>
                    <span className="font-medium text-gray-900">
                      {billing.createdAt
                        ? moment(billing.createdAt).format("MMM DD, YYYY HH:mm")
                        : "N/A"}
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="flex justify-end p-6 border-t border-gray-200">
            <button
              type="button"
              className="px-4 py-2 text-gray-700 bg-gray-100 rounded-md transition-colors duration-200 hover:bg-gray-200"
              onClick={() => setOpenModal(false)}
            >
              Close
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ViewRemarkTransaction;
